<agr-page>
  <mat-vertical-stepper linear id="stepper">
    <mat-step [stepControl]="applicationGroupFormGroup">
      <form [formGroup]="applicationGroupFormGroup">
        <ng-template matStepLabel>{{
          'wizard_step1SelectApplicationGroup' | translate
        }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_applicationGroups' | translate }}</mat-label>
          <mat-select formControlName="appGroupNameCtrl" required>
            <mat-option
              *ngFor="let applicationGroup of applicationGroups$ | async"
              [value]="applicationGroup"
            >
              {{ applicationGroup.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button color="primary" mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step2DeleteApplicationGroup' | translate }}</ng-template>
      <p>{{ 'wizard_youAreAboutToDelete' | translate }}</p>
      <ul class="app-highlights">
        <li>
          {{ 'wizard_applicationGroup' | translate }}
          <b>{{ applicationGroupFormGroup.get('appGroupNameCtrl').valueChanges | async }}</b>
        </li>
      </ul>
      <div>
        <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
        <button mat-button (click)="stepper.reset()">{{ 'wizard_reset' | translate }}</button>
        <button mat-button color="primary" (click)="complete()">
          {{ 'wizard_complete' | translate }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step3Complete' | translate }}</ng-template>
      <p>{{ 'wizard_deleteApplicationGroupSuccessMessage' | translate }}</p>
    </mat-step>
  </mat-vertical-stepper>
</agr-page>
